import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuditDtoModel } from '@heitown/common-dto';

import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class AuditApiClient extends BaseCRUDApiClient<AuditDtoModel> {
  baseUrl = this.config.apiEndpoint + '/audit';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
